export var MethodType;
(function (MethodType) {
    MethodType["SMS"] = "SMS";
    MethodType["EMAIL"] = "EMAIL";
})(MethodType || (MethodType = {}));
//# sourceMappingURL=MethodType.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/utcom-api-sdk/es/com/unitedtraders/luna/mobilegateway/registration/MethodType.js
// module id = 1522
// module chunks = 118